export default __webpack_public_path__ + "static/media/scheduleIcon.ab9dc38a.svg";